import React from 'react';
import PropTypes from 'prop-types';

const ExternalLinkIcon = ({ className = 'w-4 h-4', ...props }) => {
  return (
    <svg
      className={className}
      fill="none"
      stroke="currentColor"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14"
      />
    </svg>
  );
};

ExternalLinkIcon.propTypes = {
  className: PropTypes.string,
};

export default ExternalLinkIcon;

